export default "__VITE_ASSET__3d06c0ee__"